// The handoff ring: neighbours are separated, with 70–110 reserved for brand yellow.
// h is the numeric hue angle; dot, ink and tint retain the handoff's exact strings.
export const VARIANT_HUES = [
  { k: 'terracotta', h: 40, dot: 'oklch(0.60 0.075 40)', ink: 'oklch(0.40 0.06 40)', tint: 'oklch(0.60 0.075 40 / .12)' },
  { k: 'steel', h: 215, dot: 'oklch(0.60 0.075 215)', ink: 'oklch(0.40 0.06 215)', tint: 'oklch(0.60 0.075 215 / .12)' },
  { k: 'olive', h: 125, dot: 'oklch(0.60 0.075 125)', ink: 'oklch(0.40 0.06 125)', tint: 'oklch(0.60 0.075 125 / .12)' },
  { k: 'dusk', h: 305, dot: 'oklch(0.60 0.075 305)', ink: 'oklch(0.40 0.06 305)', tint: 'oklch(0.60 0.075 305 / .12)' },
  { k: 'copper', h: 55, dot: 'oklch(0.60 0.075 55)', ink: 'oklch(0.40 0.06 55)', tint: 'oklch(0.60 0.075 55 / .12)' },
  { k: 'slate', h: 250, dot: 'oklch(0.60 0.075 250)', ink: 'oklch(0.40 0.06 250)', tint: 'oklch(0.60 0.075 250 / .12)' },
  { k: 'sage', h: 150, dot: 'oklch(0.60 0.075 150)', ink: 'oklch(0.40 0.06 150)', tint: 'oklch(0.60 0.075 150 / .12)' },
  { k: 'mauve', h: 350, dot: 'oklch(0.60 0.075 350)', ink: 'oklch(0.40 0.06 350)', tint: 'oklch(0.60 0.075 350 / .12)' },
  { k: 'lagoon', h: 185, dot: 'oklch(0.60 0.075 185)', ink: 'oklch(0.40 0.06 185)', tint: 'oklch(0.60 0.075 185 / .12)' },
  { k: 'rosewood', h: 20, dot: 'oklch(0.60 0.075 20)', ink: 'oklch(0.40 0.06 20)', tint: 'oklch(0.60 0.075 20 / .12)' },
];

// FNV-1a over the id, including the handoff's empty/falsy-id behaviour.
export function hueIndex(id) {
  let h = 0x811c9dc5;
  const s = String(id || '');
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
  return h % VARIANT_HUES.length;
}

export const hue = id => VARIANT_HUES[hueIndex(id)];
export const byKey = k => VARIANT_HUES.find(x => x.k === k) || VARIANT_HUES[0];

// Stable for a fixed sibling set; collisions are unavoidable after ten ids.
export function hueMap(ids) {
  const taken = {}, out = {};
  [...ids].sort().forEach(id => {
    let i = hueIndex(id);
    for (let n = 0; n < VARIANT_HUES.length && taken[i]; n++) i = (i + 1) % VARIANT_HUES.length;
    taken[i] = true; out[id] = VARIANT_HUES[i];
  });
  return out;
}

// Flat profiles replace the mock client/sub-brand tree. Ready siblings take priority.
export function clientHues(variants) {
  const all = (variants || []).filter(v => v.status !== 'archived');
  const ready = all.filter(v => v.status === 'ready').map(v => v.id);
  const rest = all.filter(v => v.status !== 'ready').map(v => v.id);
  const out = hueMap(ready), taken = {};
  Object.values(out).forEach(h => { taken[h.k] = true; });
  [...rest].sort().forEach(id => {
    let i = hueIndex(id);
    for (let n = 0; n < VARIANT_HUES.length && taken[VARIANT_HUES[i].k]; n++) i = (i + 1) % VARIANT_HUES.length;
    taken[VARIANT_HUES[i].k] = true; out[id] = VARIANT_HUES[i];
  });
  return out;
}

if (typeof window !== 'undefined') {
  window.VariantsUtil = { HUES: VARIANT_HUES, VARIANT_HUES, hueIndex, hue, byKey, hueMap, clientHues };
}
